import { Alpine } from "../../../vendor/livewire/livewire/dist/livewire.esm";

Alpine.data('norkon_liveblog_tag_selector', (initialtags) => ({
  tags: initialtags.split(', '),
  selectedTag: null,
  localStorageName: 'nlc_selected_tag',
  timeoutCounter: 0,
  init() {
    this.selector = this.$refs.selector;
    this.populateSelector();

    window.addEventListener("tag-clicked-in-post", (event) => {
      if(event.detail.tag) {
        this.selectedTag = event.detail.tag;
        localStorage.setItem(this.localStorageName, this.selectedTag);
        this.setSelectorValue();
      }
    })

    // Check localstorage
    let value = localStorage.getItem(this.localStorageName);
    if(value) {
      this.selectedTag = value;
    }

    this.initializeSavedTag();
  },
  initializeSavedTag() {
    if(window.feedControl !== undefined) {
      window.feedControl.selectTag(this.selectedTag == "null" ? null : this.selectedTag);
      this.setSelectorValue();
    } else {
      if(this.timeoutCounter < 5) {
        this.timeoutCounter++;
        setTimeout(this.initializeSavedTag.bind(this), 250);
      }
    }
  },
  populateSelector() {
    this.tags.forEach((item) => {
      let option = document.createElement('option');
      option.value = item;
      option.text = item;
      this.selector.appendChild(option)
    })
  },
  setSelectorValue() {
    this.selector.value = (this.selectedTag == "null" || this.selectedTag == null) ? 0 : this.selectedTag;
  },
  changeSelectedTag(event) {
    this.selectedTag = (event.target[event.target.selectedIndex].value == "0") ? null : event.target[event.target.selectedIndex].value;
    localStorage.setItem(this.localStorageName, this.selectedTag);
    window.feedControl.selectTag(this.selectedTag);
  },
  clearSelectedTag() {
    this.selectedTag = null;
    localStorage.setItem(this.localStorageName, this.selectedTag);
    this.setSelectorValue();
    if (window.feedControl !== undefined) {
      window.feedControl.selectTag(null);
    }
  },
  
}));